import { NSARouterMakerResult } from "namirasoft-account-react";
import { Component } from "react";
import { InferenceEntities } from "../InferenceEntities";
import { InferenceInfo } from "../InferenceInfo";
import { InferenceLayout } from '../InferenceLayout';
import { InferenceRouterProps } from "../InferenceRouterProps";

interface KnowledgebaseItemListPageProps extends NSARouterMakerResult, InferenceRouterProps { }

export default class KnowledgebaseItemListPage extends Component<KnowledgebaseItemListPageProps>
{
    override render()
    {
        return (
            <InferenceLayout
                {...this.props}
                action={{ description: InferenceInfo.knowledgebase_item.list }}
                pages={{
                    entity: InferenceEntities.knowledgebase_item(this.props),
                    list: {}
                }}
            >
                <></>
            </InferenceLayout>
        );
    }
}